/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CreditCardIcon from 'DesignSystem/Svgs/CreditCardIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/CardBrand/No"
  
}) {
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<CreditCardIcon
  viewPath={`${viewPath}/CreditCardIcon`}
 width={35}
 marginTop="auto"
 marginBottom="auto"
 stroke={dtColorsNeutral700}
/>
{children}
</React.Fragment>)
}